module.exports = __webpack_public_path__ + "media/images/country_flags/ma-cd335a0049bfd0f10aad6135afc5fc35.png";